<template>
  <div class="main-layout">
    <el-image :src="imgSrc" class="page-top1" />
    <div class="main-content wh-contain-1200">
      <router-link tag="div" :to="{path: '/home'}" class="big-data">
        <el-image :src="bigSrc" class="big-icon" />
        大<br>
        数<br>
        据<br>
        平<br>
        台
      </router-link>
      <edit-side-bar @select="subMenu" @fix="fixTo" />
      <div class="main-warp">
        <router-view class="router-view" />
      </div>
    </div>
  </div>
</template>

<script>
import EditSideBar from '@/views/Info/components/EditSidebar'
export default {
  name: 'Layout',
  components: { EditSideBar },
  data() {
    return {
      imgSrc: require('../images/info-top-bg.jpg'),
      bigSrc: require('../images/big-data-icon.png'),
      curId: parseInt(this.$route.params.child) || null
    }
  },
  created() {
    this.$store.dispatch('login')
  },
  methods: {
    subMenu(data) {
      if (this.curId !== data.id) {
        this.curId = data.id
        this.$router.push({
          path: `/edit/add/${data.id}`,
          query: {
            title: data.title
          }
        })
      }
    },
    fixTo(data) {
      this.$router.push({
        path: `/edit/add/${data.id}`,
        query: {
          title: data.title
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .main-layout{
    min-width: 1200px;
    height: 100%;
  }
  .main-content{
    padding: 30px 0;
    display: flex;
    justify-content: flex-start;
    position: relative;
    .main-warp{
      flex: 1;
      margin-left: 30px;
      background-color: #fff;
      .space{
        height: 25px;
        background-color: #F9F9F9;
      }
    }
    .big-data{
      user-select: none;
      cursor: pointer;
      position: absolute;
      top: 30px;
      right: -80px;
      width: 60px;
      padding: 12px 18px;
      border-radius: 4px;
      background-color: #D9E0E6;
      font-size: 14px;
      color: #fff;
      font-weight: bold;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      &:hover{
        background-color: #d0d6db;
      }
      .big-icon{
        margin-bottom: 7px;
      }
    }
  }

  ::v-deep {
    // table
    .el-table {
    }
    .el-table__header-wrapper, .el-table tr {
      border-radius: 0;
    }
    .el-table thead {
      color: #fff;
      th {
        font-weight: 400;
      }
    }
    .el-table th {
      background: #0074C1;
    }
    .el-table--striped .el-table__body tr.el-table__row--striped td {
      background: #F3F5F9;
    }
    .el-table td, .el-table th.is-leaf {
      border-bottom: none;
    }
  }
</style>
<style>
  html, body{
    width: 100%;
    height: 100vh;
    background-color: #F9F9F9;
  }
</style>
